/*
 * Arredonda um número para duas casas decimais de forma precisa.
 * @param {number} value - O número que você deseja arredondar.
 * @returns {number} - O número arredondado para duas casas decimais.
 *
 * Exemplo de uso:
 * import { roundToTwoDecimal } from './path-to-numberUtils';
 * const myNumber = 3.146;
 * const roundedNumber = roundToTwoDecimal(myNumber);
 * console.log(roundedNumber);  // 3.15
 */
export function roundToTwoDecimal(value) {
  return Math.round((value + Number.EPSILON) * 100) / 100;
}
